<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5 bg-primary">
        <div class="app-text w-100 px-5">
          <h1 class="text-white"><span class="text-bold">TraceTB აპლიკაციის </span></h1>
          <h1 class="text-white">სამართავი პანელი</h1>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center justify-content-between text-center
                flex-column auth-bg px-5 p-lg-5 pt-7">
        <img class="pt-3" :src="imgUrl">

        <b-col class="authentication-container px-xl-2 mx-auto">
          <b-card-title class="mb-5 font-weight-bold text-center"
                        title-tag="h2">
            ავტორიზაცია
          </b-card-title>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{invalid}">
            <b-form class="auth-login-form mt-2"
                    @submit.prevent="login">
              <!-- email -->
              <b-form-group label="მომხმარებლის სახელი" class="text-left"
                            label-for="login-phone">
                <validation-provider #default="{ errors }"
                                     name="Phone"
                                     vid="phone"
                                     rules="required">
                  <b-form-input id="login-phone"
                                v-model="userPhone"
                                :state="errors.length > 0 ? false:null"
                                name="login-phone"
                                placeholder="მომხმარებლის სახელი"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group class="text-left">
                <div v-if="false" class="d-flex justify-content-between">
                  <label for="login-password">პაროლი</label>
                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>დაგავიწყდა პაროლი?</small>
                  </b-link>
                </div>
                <validation-provider #default="{ errors }"
                                     name="Password"
                                     vid="password"
                                     rules="required">
                  <b-input-group class="input-group-merge"
                                 :class="errors.length > 0 ? 'is-invalid':null">
                    <b-form-input id="login-password"
                                  v-model="password"
                                  :state="errors.length > 0 ? false:null"
                                  class="form-control-merge"
                                  :type="passwordFieldType"
                                  name="login-password"
                                  placeholder="პაროლი"/>
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer"
                                    :icon="passwordToggleIcon"
                                    @click="togglePasswordVisibility"/>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button type="submit"
                        variant="primary"
                        block
                        class="mt-3"
                        :disabled="invalid">
                შესვლა
              </b-button>
            </b-form>
          </validation-observer>

        </b-col>

        <div></div>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {ValidationProvider, ValidationObserver} from "vee-validate"
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardTitle,
  BForm,
  BButton,
  VBTooltip,
} from "bootstrap-vue"
// import useJwt from '@/auth/jwt/useJwt'
import {required, email} from "@validations"
import {togglePasswordVisibility} from "@core/mixins/ui/forms"
import store from "@/store/index"
import {getHomeRouteForLoggedInUser} from "@/auth/utils"

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import moduleAuth from "../../../store/auth/moduleAuth"


export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardTitle,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      // password: 'TraceTB,2021!',
      // userPhone: 'tracetb@gmail.com',
      userPhone: "",
      sideImg: require("@/assets/images/pages/login-v2.svg"),

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon"
    },
    imgUrl() {
      return require("@/assets/images/logo/ncdc-logo.png");
    },
  },


  created() {
    if (!moduleAuth.isRegistered) {
      this.$store.registerModule("auth", moduleAuth);
      moduleAuth.isRegistered = true
    }

  },

  methods: {
    login() {
      console.log("response.tokenResponse before")
      this.$store.dispatch("auth/login", {
        username: this.userPhone,
        password: this.password
      }).then((response) => {
        let parsed = this.parseJwt(response.tokenResponse.token);
        localStorage.setItem("userInfo", JSON.stringify(parsed));
        localStorage.setItem("userData", JSON.stringify({
          "id": 1,
          "fullName": "John Doe",
          "username": "johndoe",
          "avatar": "/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/13-small.d796bffd.png",
          "email": "admin@demo.com",
          "role": "admin",
          "ability": [{"action": "manage", "subject": "all"}],
          "extras": {"eCommerceCartItemsCount": 5}
        }));
        this.$router.replace("/")
      }).catch((err) => {});
    },

    parseJwt(token) {
      let base64Url = token.split(".")[1];
      let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      let jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));

      return JSON.parse(jsonPayload);
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.app-text {
  h1 {
    font-size: 40px;
  }
}

.authentication-container {
  flex-grow: unset;
}
</style>
